import { useNavigate, useRouterState } from '@tanstack/react-router';
import { useCallback } from 'react';
import { usePrefs } from '@/state/ui';

/** Open a task's detail over the current view (?task=id); /t/:id deep links resolve to the same. */
export function useOpenTask() {
  const navigate = useNavigate();
  const pushRecent = usePrefs((s) => s.pushRecent);
  return useCallback(
    (taskId: string) => {
      pushRecent('task', taskId);
      void navigate({
        to: '.',
        search: (prev: Record<string, unknown>) => ({ ...prev, task: taskId }),
      } as never);
    },
    [navigate, pushRecent],
  );
}

export function useCloseTask() {
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return useCallback(() => {
    if (pathname.startsWith('/t/')) {
      void navigate({ to: '/' });
      return;
    }
    void navigate({
      to: '.',
      search: (prev: Record<string, unknown>) => ({ ...prev, task: undefined }),
    } as never);
  }, [navigate, pathname]);
}

export function useOpenTaskId(): string | undefined {
  return useRouterState({
    select: (s) => {
      const m = /^\/t\/([^/]+)/.exec(s.location.pathname);
      if (m) return decodeURIComponent(m[1]!);
      const q = (s.location.search as Record<string, unknown>).task;
      return typeof q === 'string' ? q : undefined;
    },
  });
}
